














import Vue from 'vue';

export default Vue.extend({
  props: {
    value: { type: undefined, default: undefined },
    to: { type: String, default: undefined },
    color: { type: String, default: 'interaction' },
    activeColor: { type: String, default: 'positive' },
    visitedColor: { type: String, default: 'negative' },
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    isActive: false,
    isVisited: false,
  }),
  computed: {
    classList(): {} {
      return {
        [`color-${this.color}`]: !this.isActive && !this.isVisited && !this.disabled,
        [`border-color-${this.color}`]: !this.isActive && !this.isVisited && !this.disabled,
        [`color-${this.activeColor}`]: this.isActive && !this.isVisited && !this.disabled,
        [`border-color-${this.activeColor}`]: this.isActive && !this.isVisited && !this.disabled,
        [`color-${this.visitedColor}`]: this.isVisited && !this.isActive && !this.disabled,
        [`border-color-${this.visitedColor}`]: this.isVisited && !this.isActive && !this.disabled,
        'color-disabled': this.disabled,
        'border-color-disabled': this.disabled,
      };
    },
  },
  methods: {
    onActiveChange(isActive: boolean) {
      this.isActive = isActive;
    },
  },
});
